export const getMontoTotalReclamado = (procedimientos) => {
  return procedimientos?.reduce(
    (acumulador, procedimiento) => acumulador + procedimiento.montoReclamado,
    0
  );
};

export const getMontoTotalArs = (procedimientos) => {
  return procedimientos?.reduce(
    (acumulador, procedimiento) => acumulador + procedimiento.montoARS,
    0
  );
};

export const getMontoTotalAfiliado = (procedimientos) => {
  return procedimientos?.reduce(
    (acumulador, procedimiento) => acumulador + procedimiento.montoAfiliado,
    0
  );
};
